module.exports = __webpack_public_path__ + "static/img/grow6_light.66ff698a.png";